/* eslint-disable react/prop-types */
import { useState } from 'react';
import { toast } from 'react-toastify';

// @mui
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

// components
import Iconify from '../../../components/iconify';

import API from '../../../api';

export default function SubCategoryDelete({ resetPage, id }) {
  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await API.delete(`/category/subCategory/${id}`);
      const {
        data: { success },
      } = response;
      if (success === 1) {
        resetPage();
        handleClose();
        toast.success('Амжилттай устгагдлаа', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      }
    } catch (error) {
      console.error(error.message);
      toast.error(`Алдаа гарлаа дахин оролдоно уу ${error.message}`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        fullWidth
        sx={{ justifyContent: 'start', color: 'error.main' }}
        startIcon={<Iconify icon={'eva:trash-2-outline'} />}
        onClick={handleClickOpen}
      >
        Устгах
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Хүн устгах</DialogTitle>
        <DialogContent
          sx={{
            py: 1,
          }}
        >
          Устгахдаа итгэлтэй байна уу?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Цуцлах</Button>
          {loading ? (
            'Уншиж байна...'
          ) : (
            <Button onClick={handleSubmit} color="error">
              Устгах
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
